<template>
  <div
    js-half-list="parent"
    class="half-screen-list critical-component-clear"
    :style="`background-color: ${sectionSettings.backgroundColor}`"
    :class="[
      {
        [$class('hidden')]: isMobile
          ? sectionSettings.hideMobile
          : sectionSettings.hideDesktop,
      },
      sectionSettings.isFirst && 'half-screen-list--is-first',
    ]"
  >
    <div
      v-if="blockSettings"
      class="half-screen-list__container grid"
      :class="[sectionSettings.layout === 'full-bleed' &&
        'half-screen-list__container--full-bleed no-gap']"
    >
      <template
        v-for="(block, index) of blockSettings"
        :key="`half-screen-list__list-${block.blockId}-${index}`"
      >
        <div
          v-if="block.blockType === 'media-carousel'"
          class="half-screen-list__item half-screen-list__item--carousel"
          :style="block.sectionSettings?.width &&
            `--width: ${block.sectionSettings?.width}%;`"
        >
          <div
            class="half-screen-list__content"
          >
            <media-carousel
              :section-settings="block.sectionSettings"
              :slides="block.carouselSettings"
              content-placement="half"
            />
          </div>
        </div>

        <div
          v-if="block.blockType === 'media-section' || block.blockType === 'text-section'"
          class="half-screen-list__item"
          :class="[
            `half-screen-list__item--${block.blockType}`,
            // eslint-disable-next-line max-len
            `half-screen-list__item--optical-padding-${block.mediaSectionSettings.sectionSettings.opticalAdjustment}`
          ]"
          :style="block.mediaSectionSettings.sectionSettings.width &&
            `--width: ${block.mediaSectionSettings.sectionSettings.width}%;`"
        >
          <div
            class="
              half-screen-list__content
              "
            :class="
              block.mediaSectionSettings.sectionSettings.width === '100' &&
                'half-screen-list__content--full'"
          >
            <media-section
              :section-settings="block.mediaSectionSettings.sectionSettings"
              :mobile-media-settings="block.mediaSectionSettings.mobileMediaSettings"
              :desktop-media-settings="block.mediaSectionSettings.desktopMediaSettings"
              :link-settings="block.mediaSectionSettings.linkSettings"
              content-placement="half"
              :show-media="block.blockType === 'media-section'"
              :content-type="block.blockType"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Half screen list section (half-screen-list)
 * -----------------------------------------------------------------------------
 * Half Screen List Section.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
import MediaCarousel from '~async/media-carousel/media-carousel.vue'
import MediaSection from '~async/media-section/media-section.vue'
import { mapState } from 'vuex'

export default {
  name: 'HalfScreenList',
  components: {
    MediaCarousel,
    MediaSection,
  },
  props: {
    sectionSettings: {
      type: Object,
      default: () => ({
        id: '',
        backgroundColor: '',
        hideDesktop: '',
        hideMobile: '',
      }),
    },

    blockSettings: {
      type: Array,
      default: () => [],
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },

  methods: {

    /**
     * Determine if half list child should be sticky.
     * @param {Object} block - Half screen block.
     * @returns {Boolean|String}
     */
    halfListChild(block) {
      if (
        block?.blockType === 'product-grid'
      ) {
        return false
      }

      return 'child'
    },
  },
}
</script>

<style lang="scss">
@import './half-screen-list';
</style>
